import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import {
  Container,
  Loader,
  Info,
  SelectContainer,
  DetailsContainer,
  TotalRow,
} from './styles';
import api from '~/services/apiBearer';
import { store } from '~/store';
import { documentMask } from '~/util/documentInputMask';
import Table from '~/components/Table';

export default function IncomeTax() {
  // #region Attributes
  const property = useSelector(state => state.property.property);
  const [loader, setLoader] = useState(true);
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [incomeTax, setIncomeTax] = useState({});
  const { token } = store.getState().auth;

  const columns = [
    {
      Header: 'MÊS',
      columns: [{ accessor: 'mes' }],
    },
    {
      Header: () => <div style={{ textAlign: 'right' }}>ALUGUEL P.FÍSICA</div>,
      accessor: 'aluguelPF',
      Cell: props => <div style={{ textAlign: 'right' }}>{props.value}</div>,
    },
    {
      Header: () => <div style={{ textAlign: 'right' }}>ALUGUEL P.JURÍDICA</div>,
      accessor: 'aluguelPJ',
      Cell: props => <div style={{ textAlign: 'right' }}>{props.value}</div>,
    },
    {
      Header: () => <div style={{ textAlign: 'right' }}>TAXA ADMIN.</div>,
      accessor: 'taxaADM',
      Cell: props => <div style={{ textAlign: 'right' }}>{props.value}</div>,
    },
    {
      Header: () => <div style={{ textAlign: 'right' }}>I.R.R.F RETIDO</div>,
      accessor: 'irrf',
      Cell: props => <div style={{ textAlign: 'right' }}>{props.value}</div>,
    },
  ];

  function formatDate(input) {
    const datePart = input.match(/\d+/g);
    const year = datePart[0];
    const month = datePart[1];
    const day = datePart[2];
    return `${day}/${month}/${year}`;
  }

  const data = {};
  const totals = {};

  if (incomeTax && incomeTax.listaIR) {
    incomeTax.listaIR.forEach((elParent) => {
      data[elParent.inquilino] = [];
      totals[elParent.inquilino] = {
        aluguelPF: 0,
        aluguelPJ: 0,
        taxaADM: 0,
        irrf: 0
      };

      elParent.lancamentos.forEach((el) => {
        // Acúmulo dos valores para soma
        totals[elParent.inquilino].aluguelPF += el.vlrTotalAluguel || 0;
        totals[elParent.inquilino].taxaADM += el.vlrTotalComissao || 0;
        totals[elParent.inquilino].irrf += el.vlrTotalImposto || 0;

        data[elParent.inquilino].push({
          mes: formatDate(el.periodo),
          aluguelPF: `R$ ${el.vlrTotalAluguel.toLocaleString('pt-br', { minimumFractionDigits: 2 })}`,
          aluguelPJ: `R$ 0,00`,
          taxaADM: `R$ ${el.vlrTotalComissao.toLocaleString('pt-br', { minimumFractionDigits: 2 })}`,
          irrf: `R$ ${el.vlrTotalImposto.toLocaleString('pt-br', { minimumFractionDigits: 2 })}`,
        });
      });
    });
  }

  // #region Functions
  useEffect(() => {
    api.defaults.headers.Authorization = `Bearer ${token}`;

    function GetIncomeTaxDates() {
      if (property.businessId === 0) return;

      api
        .get(`api/v1/WSImpostoRenda?Negocio=${property.businessId}&exercicio&referencia=${property.reference}`)
        .then(
          response => {
            const { sucesso: success, mensagem: message, conteudo: sDates } = response.data;
            if (success) {
              setDates(sDates.listaExercicio.map(d => ({ value: d, label: d })));
            } else toast.error(message);
          },
          error => {
            toast.error('Erro interno, por favor tente novamente mais tarde.');
          }
        )
        .then(() => setLoader(false));
    }

    GetIncomeTaxDates();
  }, [property.businessId, property.reference, token]);

  function handleConsultClick() {
    if (selectedDate === '') {
      toast.error('É obrigatório selecionar um ano antes de consultar.');
      return;
    }
    setLoader(true);
    api
      .get(`api/v1/WSImpostoRenda?negocio=${property.businessId}&exercicio=${selectedDate}&referencia=${property.reference}`)
      .then(
        response => {
          const { sucesso: success, mensagem: message, conteudo: content } = response.data;
          if (success) setIncomeTax(content);
          else toast.error(message);
        },
        error => {
          toast.error('Erro interno, por favor tente novamente mais tarde.');
        }
      )
      .then(() => setLoader(false));
  }

function printStatement2(property) {
    const conteudo = document.getElementById('content_container').innerHTML;

    const main = `<html>
                  <head>
                    <title>Ref:.${property.reference}</title>
                    <style>
                      /* 1. Reset Global Essencial para Impressão */
                      @page { size: auto; margin: 10mm; }

                      html, body {
                        margin: 0;
                        padding: 15px;
                        font-family: Tahoma, Arial, sans-serif;
                        background: #fff !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                      }

                      * {
                        box-sizing: border-box !important; /* Garante que padding não aumente a largura */
                        color: #1c2156 !important;
                      }

                      /* 2. TABELA DE DADOS (Forçar layout fixo) */
                      table {
                        width: 100% !important;
                        table-layout: fixed !important; /* OBRIGATÓRIO para alinhar */
                        border-collapse: collapse !important;
                        margin-bottom: 0 !important;
                      }

                      table td, table th {
                        font-size: 11px !important; /* Tamanho seguro em PX */
                        padding: 4px !important;
                        border-bottom: 1px solid #ccc !important;
                        vertical-align: middle !important;
                        overflow: hidden;
                      }

                      /* Larguras da Tabela */
                      table th:nth-child(1), table td:nth-child(1) { width: 15% !important; }
                      table th:nth-child(n+2), table td:nth-child(n+2) { width: 21.25% !important; text-align: right !important; }


                      /* 3. TOTAL ROW (A Mágica do alinhamento) */
                      /* Transformamos a DIV em TABLE via CSS para o navegador alinhar igual */

                      .print-total-row {
                        display: table !important; /* Comporta-se como tabela */
                        table-layout: fixed !important;
                        width: 100% !important;
                        background-color: #f9f9f9 !important;
                        border: 1px solid #ddd !important;
                        border-top: none !important;
                        margin-top: -1px !important; /* Cola na tabela de cima */
                      }

                      .print-total-row span {
                        display: table-cell !important; /* Comporta-se como célula (TD) */
                        font-size: 11px !important; /* Mesmo tamanho da tabela */
                        font-weight: bold !important;
                        white-space: nowrap !important; /* Não quebrar linha */
                        padding: 6px 4px !important;
                        vertical-align: middle !important;
                        border: none !important;
                      }

                      /* Larguras do Total (IDÊNTICAS à Tabela) */
                      .print-total-row span:nth-child(1) { width: 15% !important; text-align: left !important; }
                      .print-total-row span:nth-child(n+2) { width: 21.25% !important; text-align: right !important; }


                      /* 4. Estilos Gerais */
                      .print-details-container {
                        font-size: 12px !important;
                        width: 100% !important;
                      }

                      h3, h4 {
                        border-bottom: 2px solid #f7c325 !important;
                        padding: 8px !important;
                        margin: 10px 0 !important;
                        font-size: 13px !important;
                        text-transform: uppercase;
                      }

                      .print-gray-line {
                        border-bottom: 1px solid #ccc !important;
                        margin: 10px 0 !important;
                        display: block;
                      }

                      /* Ocultar botões e scrollbars */
                      button { display: none !important; }
                      ::-webkit-scrollbar { display: none; }
                    </style>
                  </head>
                  <body>
                    ${conteudo}
                  </body>
                </html>`;

    const tela_impressao = window.open('', 'Extrato', 'resizable,scrollbars');
    tela_impressao.document.write(main);

    setTimeout(() => {
      tela_impressao.document.close();
      tela_impressao.window.print();
      tela_impressao.window.close();
    }, 600);
  }

  return (
    <Container>
      <Loader style={{ display: loader ? 'block' : 'none' }} />

      <Info>
        <h3>Ref.: {property.reference}</h3>
        <h3>Nº do Negócio: {property.businessId}</h3>
        <h3 className="title">
          <p>Imposto de Renda</p> {property.address}
        </h3>
      </Info>

      <SelectContainer>
        <Select
          placeholder="Selecione o ano"
          noOptionsMessage={() => 'Nenhum ano encontrado'}
          options={dates}
          onChange={item => setSelectedDate(item.value)}
        />
        <button onClick={handleConsultClick} type="button">Consultar</button>
      </SelectContainer>

      <div id="content_container">
        {incomeTax && incomeTax.listaIR && (
          <DetailsContainer>
            <div>
              <h4>INFORMAÇÕES REFERENTE AO IMPOSTO DE RENDA ANO BASE {selectedDate}</h4>
            </div>
          </DetailsContainer>
        )}

     {incomeTax && incomeTax.listaIR ? (
  incomeTax.listaIR.map(incomeTaxItem => (
    <React.Fragment key={incomeTaxItem.inquilino}>

      {/* 1. ADICIONADA A CLASSE AQUI */}
      <DetailsContainer className="print-details-container">
        <div>
          <div id="img">
            <section style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <section style={{ alignItems: 'flex-start' }}>
                <span className="bold">INQUILINO</span>
                <span>{incomeTaxItem.lancamentos[0].nomeInquilino}</span>
                <span>CPF/CNPJ: {documentMask(incomeTaxItem.lancamentos[0].documentoInquilino)}</span>
              </section>
              <section className="addressSection" style={{ alignItems: 'flex-start' }}>
                <span className="bold">ENDEREÇO DO(S) IMÓVEL(EIS)</span>
                <span>{incomeTaxItem.lancamentos[0].enderecoBem}</span>
                <span>Contrato: {incomeTaxItem.lancamentos[0].idContrato}</span>
              </section>
            </section>
            <br />
            <div className="print-gray-line" />
            <br />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span className="bold">ALUGUÉIS MENSAIS: </span>
              <span className="bold" style={{ marginRight: '107px' }}>DEMONSTRATIVOS DE VALORES</span>
            </div>
            <br />
            <Table columns={columns} data={data[incomeTaxItem.inquilino]} />

            {/* 2. ADICIONADA A CLASSE AQUI */}
            <TotalRow className="print-total-row">
              <span>TOTAIS:</span>
              <span>R$ {totals[incomeTaxItem.inquilino].aluguelPF.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</span>
              <span>R$ {totals[incomeTaxItem.inquilino].aluguelPJ.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</span>
              <span>R$ {totals[incomeTaxItem.inquilino].taxaADM.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</span>
              <span>R$ {totals[incomeTaxItem.inquilino].irrf.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</span>
            </TotalRow>

            <br />
            <span style={{ fontWeight: 'bold', fontSize: '11px', fontStyle: 'italic' }}>
              OS VALORES ACIMA REFEREM-SE AOS PERÍODOS DE EFETIVO CRÉDITO.
            </span>
          </div>
        </div>
      </DetailsContainer>
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <button onClick={() => printStatement2(property)} type="button">IMPRIMIR</button>
      </div>
    </React.Fragment>
  ))
) : null}
      </div>
    </Container>
  );
}
